module.exports = __webpack_public_path__ + "static/media/ad-banner-gift-cards.7654a7ef.jpg";